import { render } from "./SendEmailDialog.vue?vue&type=template&id=3bf788ce"
import script from "./SendEmailDialog.vue?vue&type=script&lang=js"
export * from "./SendEmailDialog.vue?vue&type=script&lang=js"

import "./SendEmailDialog.vue?vue&type=style&index=0&id=3bf788ce&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__